<template>
  <v-alert
    type="info"
    class="mb-0"
    variant="outlined"
    text
  >
    <v-row align="center">
      <v-col class="grow">
        <div class="error-text">
          {{ $t('topics.list.errors.max-active-topics.0', { maxActiveTopics }) }}<br />
          {{ $t('topics.list.errors.max-active-topics.1') }}
          <!-- Use wrapper span to track the event as @click is not called on <router-link> -->
          <span
            @click="
              $tracking.event(
                'Marketing Topics',
                'Clicked',
                'Upgrade',
                'MaxActiveTopicsReachedAlert'
              )
            "
          >
            <a
              v-if="isPlatformSmg"
              :href="helpArticleLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('topics.list.errors.max-active-topics.2') }}
            </a>
            <router-link
              v-else
              :to="upgradeLink"
            >
              {{ $t('topics.list.errors.max-active-topics.2') }}
            </router-link>
          </span>
        </div>
      </v-col>
      <v-col class="shrink">
        <v-btn
          icon
          class="text-info"
          @click="dismiss"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import brandingMixin from '@/mixins/branding.js'

export default {
  mixins: [brandingMixin],
  props: {
    maxActiveTopics: {
      type: Number,
      required: true,
    },
  },
  computed: {
    helpArticleLink() {
      return this.upgradePackageUrl
    },
    upgradeLink() {
      return {
        name: 'Settings',
        params: { section: 'contract' },
        query: { showUpgrade: '1' },
      }
    },
  },
  methods: {
    dismiss() {
      this.$emit('dismiss')
    },
  },
  emits: ['dismiss'],
}
</script>
